
import { Union } from "../../fable-library-js.5.13.0/Types.js";
import { Common_parseOptions, Color_ofColor, Common_GenericOptions__AddModifiers_Z7C3AFA3, Common_GenericOptions__AddClass_Z721C83C5, Common_GenericOptions__AddProps_Z4E55E0BD, Common_GenericOptions__AddCaseName_1505, Common_GenericOptions_Parse_Z4D1A7726, Common_GenericOptions__ToReactElement_4509C2D7, Modifier_IModifier_$reflection, Color_IColor_$reflection } from "../Common.fs.js";
import { union_type, list_type, class_type, string_type } from "../../fable-library-js.5.13.0/Reflection.js";
import * as react from "react";
import { keyValueList } from "../../fable-library-js.5.13.0/MapUtil.js";

export class Option extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Color", "is-light", "CustomClass", "Props", "Modifiers"];
    }
    static IsLight = new Option(1, []);
}

export function Option_$reflection() {
    return union_type("Fulma.Notification.Option", [], Option, () => [[["Item", Color_IColor_$reflection()]], [], [["Item", string_type]], [["Item", list_type(class_type("Fable.React.IHTMLProp"))]], [["Item", list_type(Modifier_IModifier_$reflection())]]]);
}

/**
 * Generate <div class="notification"></div>
 */
export function notification(options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, (result, option) => {
        switch (option.tag) {
            case 1:
                return Common_GenericOptions__AddCaseName_1505(result, option);
            case 3:
                return Common_GenericOptions__AddProps_Z4E55E0BD(result, option.fields[0]);
            case 2:
                return Common_GenericOptions__AddClass_Z721C83C5(result, option.fields[0]);
            case 4:
                return Common_GenericOptions__AddModifiers_Z7C3AFA3(result, option.fields[0]);
            default:
                return Common_GenericOptions__AddClass_Z721C83C5(result, Color_ofColor(option.fields[0]));
        }
    }, "notification"), (props_1, children_1) => react.createElement("div", keyValueList(props_1, 1), ...children_1), children);
}

/**
 * Generate <button class="delete"></button>
 */
export function delete$(options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, Common_parseOptions, "delete"), (props, children_1) => react.createElement("button", keyValueList(props, 1), ...children_1), children);
}

